import React, { FC } from 'react';
// import Phone from './icon_call_dark.svg';

const mcsInputStyle = {
  // backgroundImage: `url(${Phone})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '20px',
  backgroundPosition: '4px 6px',
  border: 'rgb(204, 204, 204) 1px solid',
  borderRadius: '16px',
  fontSize: '14px',
  color: 'black',
  margin: '5px 5px',
  'box-sizing': 'content-box',
  '-moz-box-sizing': 'content-box',
  padding: '4px 0 4px 32px',
  height: '24px',
  fontWeight: 'bold'
};

interface MCSInputProps {
  phoneNumber: string;
  updatePhoneNumber: (val: string) => void;
  display: boolean;
}

const MobileCameraShareInput: FC<MCSInputProps> = (
  mcsInputProps: MCSInputProps
) => {
  const { phoneNumber, updatePhoneNumber, display } = mcsInputProps;

  return display ? (
    <input
      style={mcsInputStyle}
      type="tel"
      autoFocus
      value={formatPhoneNumber(phoneNumber)}
      placeholder={'(555) 555-555'}
      onChange={(e) => updatePhoneNumber(e.target.value)}
    />
  ) : null;
};

export default MobileCameraShareInput;

const formatPhoneNumber = (phoneNumber: string): string => {
  let formattedPhoneNumber = '';

  if (phoneNumber.length) {
    formattedPhoneNumber =
      phoneNumber.at(0) !== '(' ? `(${phoneNumber}` : phoneNumber;
  }

  if (phoneNumber.length === 4) {
    formattedPhoneNumber += ') ';
  }

  if (phoneNumber.length === 9) {
    formattedPhoneNumber += '-';
  }

  return formattedPhoneNumber;
};
